import React, { useEffect, useState } from 'react';
import { WifiOff } from 'lucide-react';

const OfflineBanner = () => {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const goOffline = () => setIsOffline(true);
    const goOnline = () => setIsOffline(false);
    window.addEventListener('offline', goOffline);
    window.addEventListener('online', goOnline);
    return () => {
      window.removeEventListener('offline', goOffline);
      window.removeEventListener('online', goOnline);
    };
  }, []);

  if (!isOffline) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[60] bg-amber-50 dark:bg-amber-900/80 border-b border-amber-200 dark:border-amber-700 px-4 py-2.5 flex items-center justify-center gap-2" role="alert" aria-live="assertive">
      <WifiOff size={15} className="text-amber-600 dark:text-amber-400" />
      <span className="text-sm font-medium text-amber-800 dark:text-amber-200">No internet connection. Uploads will resume automatically when you are back online.</span>
    </div>
  );
};

export default OfflineBanner;
